import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import {
  ResidentAppAsideSection,
  ResidentAppAsideText,
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { ReservationCalendars } from '../ReservationCalendars'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'
import { ReservationsList } from '../../components/ReservationsList'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

import { ReservationRulesAndTermsLinks } from 'components'

export const CommonAreaReservations: React.FC = () => {
  const { t } = useTranslation(['common', 'reservations', 'titles'])
  const moduleConfig = useModuleConfig()
  const { frontPagePath } = useContractPaths()
  const { currentContractId } = useCurrentContract()

  const moduleLinks: { href: string; label: string }[] = []
  const commonAreaConfig = moduleConfig.commonAreaReservations
  if (commonAreaConfig?.contractDocumentLink) {
    moduleLinks.push({
      href: commonAreaConfig.contractDocumentLink,
      label: t('reservations:modal.commonAreaRulesLink'),
    })
  }
  if (commonAreaConfig?.termsOfUseDocumentLink) {
    moduleLinks.push({
      href: commonAreaConfig.termsOfUseDocumentLink,
      label: t('reservations:modal.commonAreaTermsLink'),
    })
  }

  return (
    <TitleController title={t('titles:commonAreaReservations')}>
      <ResidentAppView
        title={t('reservations:pageTitleCommonAreas')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
        aside={
          <ResidentAppAsideSection>
            <ResidentAppAsideText>
              {t('reservations:commonAreaSidebarDescription')}
            </ResidentAppAsideText>
            <ReservationRulesAndTermsLinks
              contractId={currentContractId}
              reservableCategory="reservable_common_area"
              realPropertyHierarchyId={null}
              fallbackLinks={moduleLinks}
            />
            <ReservationsList reservableCategory="reservable_common_area" />
          </ResidentAppAsideSection>
        }
      >
        <ResidentAppCard>
          <ReservationCalendars reservableCategory="reservable_common_area" />
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
